import {Component, OnInit, SimpleChanges} from '@angular/core';
import {FileImportTO} from "../../../classes/file-import-to";

@Component({
  selector: 'app-import-sprout',
  templateUrl: './import-sprout.component.html',
  styleUrls: ['./import-sprout.component.css'],
})
export class ImportSproutComponent implements OnInit {

  public fileImportTO: FileImportTO;

  constructor() { }

  ngOnInit() {
    console.log('ImportSproutComponent.ngOnInit');
  }

  setFileImportTO(fileImportTO: FileImportTO) {
    this.fileImportTO = fileImportTO;
  }
}
